import React, { ReactNode } from "react"
import AliceCarousel from "react-alice-carousel"
import "react-alice-carousel/lib/alice-carousel.css"

const responsive = {
  0: { items: 2 },
  568: { items: 3 },
  1024: { items: 4 }
}

interface Props {
  children: ReactNode
  infinite?: boolean
}
const Carousel = (props: Props) => {
  const { children, infinite = true } = props
  return (
    <AliceCarousel
      autoPlay
      infinite={infinite}
      autoPlayInterval={1000}
      responsive={responsive}
      disableButtonsControls={false}
    >
      {children}
    </AliceCarousel>
  )
}
export default Carousel
